import { v4 as uuidv4 } from "uuid";
import cogoToast from "cogo-toast";
const { createSlice } = require("@reduxjs/toolkit");

let toastTimeout;


const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
  },
  reducers: {
    updateToCart(state, action) {
      const product = action.payload;
      const existingProduct = state.cartItems.find(
        (item) => item.id === product.ID
      );
      existingProduct.quantity = product.quantityCount;
      cogoToast.info("Product quantity updated in cart", {
        position: "bottom-left",
      });
    },
    addToCart(state, action) {
      const product = action.payload;
      const existingProduct = state.cartItems.find(
        (item) => item.id === product.ID && item.variantId === product.variantId
      );
      if (existingProduct) {
        // If product exists (including variant), increment its quantity
        existingProduct.quantity = product.quantityCount
          ? product.quantityCount
          : existingProduct.quantity + 1;
        cogoToast.info("Product quantity increased", {
          position: "bottom-left",
        });
      } else {
        // If product doesn't exist, add it as a new item
        state.cartItems.push({
          ...product,
          quantity: product.quantityCount ? product.quantityCount : 1,
          cartItemId: uuidv4(),
          price: product.price,
          markedPrice: product.markedPrice,
          imagePath: product?.images[0]?.imagePath,
          id: product.ID,
          ...(product.variantId && { variantId: product.variantId }), // Add variantId only if it exists
        });
        cogoToast.success("Item added to your cart", { position: "bottom-left" });
      }
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter(
        (item) => item.cartItemId !== action.payload
      );
      cogoToast.error("Removed From Cart", { position: "bottom-left" });
    },
    decreaseQuantity(state, action) {
      const product = action.payload;
      if (product.quantity === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.cartItemId !== product.cartItemId
        );
        cogoToast.error("Removed From Cart", { position: "bottom-left" });
      } else {
        state.cartItems = state.cartItems.map((item) =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
        if (toastTimeout) clearTimeout(toastTimeout);
        toastTimeout = setTimeout(() => {
          cogoToast.warn("Decreased item quantity in cart", {
            position: "bottom-left",
          });
        }, 800);
      
      }
    },
    increaseQuantity(state, action) {
      const product = action.payload;

      state.cartItems = state.cartItems.map((item) =>
        item.cartItemId === product.cartItemId
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );

    if (toastTimeout) clearTimeout(toastTimeout);
     toastTimeout = setTimeout(() => {
      cogoToast.warn("Increased item quantity in cart", {
        position: "bottom-left",
      });
    }, 800);
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
    },
  },
});

export const {
  addToCart,
  deleteFromCart,
  decreaseQuantity,
  increaseQuantity,
  deleteAllFromCart,
  updateToCart,
} = cartSlice.actions;
export default cartSlice.reducer;
